import styled from "styled-components";
import { getBreakpoints } from "../../../assets/store/cssBreakpoints";
const { xs, sm, md, lg, xl, xxl } = getBreakpoints();

export const AmenityLink = styled.li`
    &&& {
        display: flex;
        align-items: center;
        text-align: left;
        color: ${(props) =>
            props.linkColor ? props.linkColor : "#000"} !important;
        cursor: pointer;
        margin: 5px 0;
        width: fit-content;
        font-family: inherit;
        font-size: inherit;
        gap: 7px;
        padding: 2px 0;

        &:hover {
            color: ${(props) =>
                props.hoverColor ? props.hoverColor : "#fff"} !important;
        }

        @media screen and (max-width: ${xl}px) {
            font-size: unset;
        }
    }
`;

export const AmenityNoLink = styled.li`
    &&& {
        display: flex;
        align-items: center;
        text-align: left;
        margin: 5px 0;
        width: fit-content;
        font-family: inherit;
        font-size: inherit;
        gap: 7px;
        padding: 2px 0;
        color: ${(props) => (props.textColor ? props.textColor : "black")};

        @media screen and (max-width: ${xl}px) {
            font-size: unset;
        }
    }
`;
